import SEO from "../../common/SEO";
import HeaderTwo from "../../common/header/HeaderThree";
import FooterFour from "../../common/footer/FooterThreeAlt";
import SampleOne from "../../elements/portfolio/SampleOne";
import SectionTitle from "../../elements/sectionTitle/SectionTitle";

const Test = () => {
  return (
    <>
      <SEO title="Sample Page" />

      <main className="page-wrapper">
        <HeaderTwo btnStyle="btn-small" HeaderSTyle="header-transparent" />
        <div
          className="slider-area slider-style-3 height-750  bg_image bg_image_fixed"
          data-black-overlay="2"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg/bg-image-1.jpg)`,
          }}
        >
          <div className="container">
            <div className="row">
              <div className="order-2 order-lg-1 col-lg-8 mt_md--50 mt_sm--50 mt_lg--30">
                <div className="inner pt--80 text-left">
                  <h1 className="title pt--80 theme-gradient">Sample Units</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="main-content">
          <div className="rwt-portfolio-area rn-section-gap">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <SectionTitle
                    textAlign="text-center"
                    radiusRounded=""
                    title="A sample of our skill units!"
                    description=""
                  />
                </div>
              </div>
              <SampleOne Column="col-lg-4 col-md-6 col-sm-12 col-12 mt--30 portfolio" />
            </div>
          </div>
        </div>

        <FooterFour />
      </main>
    </>
  );
};

export default Test;
